/**
 * ⌘I / ⌘B in a cue's text (1.9.0): wrap the selected words in <i>…</i> or <b>…</b>, or take the tags away when the
 * selection is already wrapped in them. With nothing selected the whole text is wrapped (or unwrapped).
 */
export interface TextSelection { text: string; start: number; end: number }

export function toggleInlineTag(text: string, start: number, end: number, tag: 'i' | 'b' | 'u'): TextSelection {
  const open = `<${tag}>`, close = `</${tag}>`;
  let a = Math.max(0, Math.min(start, end, text.length)), b = Math.min(text.length, Math.max(start, end));
  if (a === b) { a = 0; b = text.length; }
  const inner = text.slice(a, b);
  // Selected with its tags: <i>words</i>.
  if (inner.startsWith(open) && inner.endsWith(close) && inner.length >= open.length + close.length) {
    const body = inner.slice(open.length, inner.length - close.length);
    return { text: text.slice(0, a) + body + text.slice(b), start: a, end: a + body.length };
  }
  // Selected inside its tags: <i>[words]</i>.
  if (text.slice(Math.max(0, a - open.length), a) === open && text.slice(b, b + close.length) === close) {
    return { text: text.slice(0, a - open.length) + inner + text.slice(b + close.length), start: a - open.length, end: b - open.length };
  }
  if (!inner) return { text, start, end };
  return { text: text.slice(0, a) + open + inner + close + text.slice(b), start: a + open.length, end: b + open.length };
}
